import React, {useEffect, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Server.css';

import { faPeopleGroup, faMap, faServer } from '@fortawesome/free-solid-svg-icons';

export default function() {

    const [serverData, setServerData] = useState([])
    const bannerPlaceholder = 'https://pbs.twimg.com/media/EcBR-Y5XsAIuljs.png'

    useEffect(() => {
        fetchServerData();
        setInterval(async () => {
            fetchServerData();
        }, 30000);
    }, []);

    async function fetchServerData() {
        await fetch('https://join.valorian-at-war.de/api/v1/status').then(res => res.json()).then((result) => {
            setServerData(result.data);
        })
    }

    return (
        <servers>
            {
                serverData.map(server => (
                    <card>
                        <cardHeader>
                            <img src={server?.images?.banner ? server.images.banner : bannerPlaceholder}/>
                        </cardHeader>
                        <p style={{backgroundColor: server?.themeColor}}>{server?.name}</p>
                        <cardInformations>
                            <ul>
                                <li className={'cardStatus'}>
                                    <span className={server?.is_online ? 'statusOnline' : 'statusOffline'}>
                                        { server?.is_online ? 'online' : 'offline' }
                                    </span>
                                </li>
                                <li>
                                    <FontAwesomeIcon className="icon" icon={faPeopleGroup}/>&nbsp;
                                    <span> { `| ${server?.players} / ${server?.maxplayers}` }</span>
                                </li>
                                <li>
                                    <FontAwesomeIcon className="icon" icon={faMap}/>&nbsp;
                                    <span> { `| ${server?.map}`}</span>
                                </li>
                                <li>
                                    <FontAwesomeIcon className="icon" icon={faServer}/>&nbsp;
                                    <span> { `| ${server?.ip}:${server?.port}` }</span>
                                </li>
                            </ul>
                        </cardInformations>
                        
                        <a className={'joinButton'} href={`steam://connect/${server?.ip}:${server?.port}`}>Beitreten</a>
                    </card>
                ))
            }
        </servers>
    )
}